<template>
  <img src="../../../assets/image/map_en.png" style="width: 100vw">
  <div class="contact_page_text">
    <br/>
        <p style="color: black; font-size: 26px; margin-bottom: 1vh;font-weight: bold">CONTACT US</p>
        <p>Headquartered in the US, SIG is a global proprietary trading and
          broker-dealer firm founded with an
          entrepreneurial mindset</p>
        <p>and a rigorous analytical approach to decision making.</p>
        <p>Over the past 30 years, SIG's business thrives at the intersection of
          trading, quantitative research, and
          technology.</p>
        <p>SIG now has over 2,500 employees worldwide.</p>
        <p></p>
        <p style="margin-top: 20px;font-size: 16px">Shanghai address</p>
        <p>Suite 1705-11, 1 Corporate Avenue, 222 Hu Bin Road, Huangpu District, Shanghai 200021</p>
        <p>Tel: (+86) 21-61222888</p>
        <p style="margin-top: 20px;font-size: 16px">Beijing address</p>
        <p>Suite 1908, East Tower, Twin Towers, B-12 Jianguomenwai Avenue, Chaoyang District, Beijing 100022</p>
        <p>Tel: (+86) 10-65665096</p>
        <br/>
      </div>

</template>
<script>

export default {
  name: 'Contact_page_en_m',
  components: {},
}
</script>
<style scoped>

.contact_page_text p {
  color: grey;
  margin-bottom: 0;
  font-size: 12px;
}

.contact_page_text {
  margin-left: 8.33vw;
  margin-right: 8.33vw;
  text-align: left;
}
</style>
